import { render, staticRenderFns } from "./FundDetailsFields.vue?vue&type=template&id=1be5cdfb&scoped=true&"
import script from "./FundDetailsFields.vue?vue&type=script&lang=ts&"
export * from "./FundDetailsFields.vue?vue&type=script&lang=ts&"
import style0 from "./FundDetailsFields.vue?vue&type=style&index=0&id=1be5cdfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be5cdfb",
  null
  
)

export default component.exports